import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=dbcd616c&scoped=true&"
import script from "./vip.vue?vue&type=script&lang=js&"
export * from "./vip.vue?vue&type=script&lang=js&"
import style0 from "./vip.vue?vue&type=style&index=0&id=dbcd616c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcd616c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbcd616c')) {
      api.createRecord('dbcd616c', component.options)
    } else {
      api.reload('dbcd616c', component.options)
    }
    module.hot.accept("./vip.vue?vue&type=template&id=dbcd616c&scoped=true&", function () {
      api.rerender('dbcd616c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/limitPrice/vip.vue"
export default component.exports